module.exports = __webpack_public_path__ + "static/media/columns.0d836fb1.svg";